
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/market-conduct/laws-regulations",
      function () {
        return require("private-next-pages/compliance/market-conduct/laws-regulations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/market-conduct/laws-regulations"])
      });
    }
  